// src/App.js
import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Pages
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import Patient from "./pages/Patient"; // works whether the file is Patient.jsx or Patient.js

function AppRoutes() {
  const loc = useLocation();

  // --- Client-side normalization for old /app/* links ---
  // If someone opens /app/login, /app/dashboard, /app/patient/..., strip the /app prefix
  // so the current bundle's routes match and we avoid the flash-then-white issue.
  if (loc.pathname.startsWith("/app/")) {
    const normalized =
      loc.pathname.replace(/^\/app/, "") + (loc.search || "") + (loc.hash || "");
    return <Navigate to={normalized || "/"} replace />;
  }

  return (
    <Routes>
      {/* Always land on Login when visiting the root */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot" element={<ForgotPassword />} />

      {/* App */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/patient/:patientId" element={<Patient />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AppRoutes />;
}
